<template>
  <div>
    <div style="background: #000;" id="h0">
      <div class="header" id="header" :class="{'fix-nav': navBarFixed}">
        <div class="kw clearfix">
          <div class="headerLeft">
            <router-link to="/" class="haderLogo">
              <img src="@/assets/images/logo.png" />
            </router-link>
          </div>


          <div class="headerRight">
            <div class="headerNav">
              <a href="javascript:;" @click="scrollToSection('h1')" class="headerNavItem"><span>JS EXHIBITION</span></a>
              <a href="javascript:;" @click="scrollToSection('h2')" class="headerNavItem"><span>VISION</span></a>
              <a href="javascript:;" @click="scrollToSection('h3')" class="headerNavItem"><span>LIVE COMMUNICATION</span></a>
              <a href="javascript:;" @click="scrollToSection('h4')" class="headerNavItem"><span>GLOCALIZATION</span></a>
              <a href="javascript:;" @click="scrollToSection('h5')" class="headerNavItem"><span>DIFFERENTIAL</span></a>
            </div>

            <areaNav />

          </div>



        </div>
      </div>



        <div class="homeBanner" style="padding-top: 120px;">

          <div style="max-width: 1380px; margin: 0 auto; position: relative;">
            <div class="homeBannerMap">
              <iframe src="/map/" scrolling="no" style="height:100%; width:100%; border:none; overflow: hidden"></iframe>
            </div>

            <div class="homeBannerFix">
              <div class="homeBannerFixTitle"><img src="@/assets/images/homeBannerText.png" /></div>
              <!-- <div class="homeBannerFixTitle">Exhibiting Service<br/>Worldwide</div> -->


              <div class="">
                <img src="@/assets/images/image_bak.gif" />
              </div>
            </div>
          </div>





          <!-- <img src="@/assets/images/p1.png" /> -->
        </div>

        <div class="homeAbout" id="h1">
          <div class="homeAboutBg">
            <img src="@/assets/images/blockBg.png" />
          </div>
          <div class="kw clearfix">
            <div class="homeAboutLeft">
              <div class="wow animate__fadeInLeft" data-wow-duration=".6s">
                JS Exhibition is a live communication company dedicated to full value chain of exhibiting services worldwide. We serve for trade show, showroom, theme exhibition hall, interactive branding, franchised store, roadshows, conference, launch meeting, advertising promotions. At the same time, we utilize our state of the art DR tour technology to provide solutions for online Digital Realistic display space. Our companies and creative centers around the world serve your brand in more than 150 countries and regions, presenting your brand and product ideas to people, enhancing your brand awareness and attraction.
              </div>
            </div>
            <div class="homeAboutRight ">
              <img src="@/assets/images/p2.png" class="wow  animate__fadeInRight" data-wow-duration=".6s" />
            </div>
          </div>

        </div>




      <div class="homeRow1" id="h2">
        <div class="homeRow1Fix">
          <img src="@/assets/images/p4.png" style="max-width: initial !important;" class="wow animate__fadeInUp" data-wow-duration=".6s" />
        </div>
        <div class="homeRow1Bg"><img src="@/assets/images/p3.jpg" class="wow animate__fadeIn" data-wow-duration=".6s" /></div>
      </div>

      <div class="homeRow2 wow animate__fadeInUp" data-wow-duration=".6s">
        <div class="kw">
          <div class="homeTabs">
            <div class="homeTabsLeft">
              <a href="javascript:;" class="homeTabsNav" v-for="(item,index) in visionListNav" :class="{'active':visionListNavIndex == index}" @click="visionTabsClick(index)">{{item}}</a>
            </div>
            <div class="homeTabsRight">
              <div class="listOne" v-if="visionListNavIndex == 0">
                <div class="listOnePad">
                  <div class="listOneItem" v-for="(item,j) in visionList">
                    <div class="listOneItemPad">
                      <div class="listOnePic"><img :src="item.pic"/></div>
                      <div class="listOneFoot">
                        <div class="listOneTitle">{{item.title}}</div>
                        <div class="listOneText">
                          {{item.content}}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <div class="listOne" v-if="visionListNavIndex == 1">
                <img src="@/assets/images/p41.png" />
              </div>
            </div>
          </div>
        </div>
      </div>


      <div class="homeRow1" id="h3">
        <div class="homeRow1Fix">
          <img src="@/assets/images/p7.png" style="max-width: initial !important; max-height:680px" class="wow animate__fadeInUp" data-wow-duration=".6s" />

          <!-- <img src="@/assets/images/p77.png" style="position: absolute; left: 50%; transform: translateX(-50%); bottom: -120px;" /> -->
        </div>
        <div class="homeRow1Bg"><img src="@/assets/images/p6.jpg" class="wow animate__fadeIn" data-wow-duration=".6s" /></div>
      </div>

      <div class="liveRow">
        <div class="f30 wow animate__fadeInLeft" data-wow-duration=".6s" style="color: #00a7ff;">Live Communication</div>
        <div class="liveRowText wow animate__fadeInRight" data-wow-duration=".6s">
          <p>For us, successful exhibiting and display mean that it let people feel and experience the brand with their own understanding, to experience the story behind the brand, to record the exciting moments and to create an unforgettable brand experience. We are sure that every brand experience will be unique.</p>
          <p>JS Exhibition is a leading live communication company with many doers, thinkers, architects, consultants, analysts, trend-driving rangers and innovators. JS Exhibition leads the innovative driving force of exhibiting and display, and we plan, design and implement every live communication events with great innovation and effectiveness from trade show, interactive brand promotion, corporate show room, franchised store, roadshows, conference, launch meeting, advertising promotions, to online Digitized Reality tour.</p>
        </div>
      </div>


      <div class="homeRow1" id="h4">
        <div class="homeRow1Fix">
          <img src="@/assets/images/p9.png" style="max-width: initial !important;" class="wow animate__fadeInUp" data-wow-duration=".6s" />

        </div>
        <div class="homeRow1Bg"><img src="@/assets/images/p8.jpg" class="wow animate__fadeIn" data-wow-duration=".6s" /></div>
      </div>


      <div class="liveRow kw">
        <div class="homeRow1Text "  style=" margin-top: 10px;">
          <div class="wow animate__fadeInUp" data-wow-duration=".6s">As proximity is at the heart of our values, we have established companies in Asia, North America, Europe and Middle East. <br/>This international presence allows us to support each customer as closely as possible on exhibiting service.  JS Exhibition has established itself on the international stage as a leading exhibiting industry, supporting many famous brands in exercising their global branding, but also executing exhibiting projects worldwide.</div>
        </div>
      </div>


      <div class="homeRow1" id="h5">
        <div class="homeRow1Fix">
          <img src="@/assets/images/p11.png" style="max-width: initial !important; display: block;" class="wow animate__fadeInUp" data-wow-duration=".6s" />
        </div>
        <div class="homeRow1Bg"><img src="@/assets/images/p10.jpg" style="display: block;" class="wow animate__fadeIn" data-wow-duration=".6s" /></div>
      </div>




    </div>

    <div style="background: #1a1a1a;">
      <div class="kw1180">
        <div class="homeText">
          <div class="homeTextTitle">
            Exhibiting Service Worldwide
          </div>
          <div class="homeTextMain">
            <p>It is precisely because we have six subsidiaries and nine creative centers around the world, so that every JS's employee is given the ability to activate the brand. Our employees have a range of talents, including strategic planning, creative design, fabrication, on-site execution, logistics and warehousing, service maintenance and other fields.</p>
            <p>In addition, we have the natural advantages of global design, management and execution, and we serve customers in more than 150 countries and regions. All customers enjoy the same comprehensive one-stop service at both domestic and international exhibitions. At the same time, our network of partners has been extended to the world.</p>
          </div>
        </div>


        <div class="homeText">
          <div class="homeTextTitle">
            "5E"Creative Concept
          </div>
          <div class="homeTextMain">

            <p>We have always adhered to the concept of the "5E" space creative system and this is our creative guideline in more than 150 countries. </p>
            <p>The "5E" concept has been recognized and praised by our industry and customers.</p>
            <p>In the future, we will take the "5E" concept as the starting point, adhere to the creative quality, and integrate the business thinking of design aesthetics and the deep understanding of international cross-border culture into our works. </p>
            <p>We will offer your brand more internationalized creativity.</p>

            <div class="tc pt20">
              <img src="@/assets/images/p12.jpg" />
            </div>
          </div>
        </div>


        <div class="homeText" style="border: none;">
          <div class="homeTextTitle">
            Brand Connection
          </div>
          <div class="homeTextMain">
            <p>Our difference is simple. We think, create, and execute. We connect your brand with people across the country and across the oceans. We also connect with you. Here you can see…</p>
            <div class="tc pt20">
              <img src="@/assets/images/p13.jpg" />
            </div>
          </div>
        </div>
      </div>
    </div>


    <div class="footer">
      <div class="kw clearfix">
        <div class="footerLeft">
          <div class="footerLink">
            <div class="f18 fb">About us</div>

            <div class="pt25">
              <div class="footerLinkItem"><a href="javascript:;" @click="scrollToSection('h1')">JS EXHIBITION</a></div>
              <div class="footerLinkItem"><a href="javascript:;" @click="scrollToSection('h2')">VISION</a></div>
              <div class="footerLinkItem"><a href="javascript:;" @click="scrollToSection('h3')">LIVE COMMUNICATION</a></div>
              <div class="footerLinkItem"><a href="javascript:;" @click="scrollToSection('h4')">GLOCALIZATION</a></div>
              <div class="footerLinkItem"><a href="javascript:;" @click="scrollToSection('h5')">DIFFERENTIAL</a></div>
            </div>
          </div>

          <div class="footerLink">
            <div class="f18 fb">Contact us</div>

            <div class="pt25">
              <div class="footerLinkItem"><span class="footerLinkIcon"><i class="iconfont icon-email"></i>info@jsexhibition.com</span></div>
              <div class="footerLinkItem"><span class="footerLinkIcon"><i class="iconfont icon-dianhua"></i>400-104-0518</span></div>
              <div class="footerLinkItem"><span class="footerLinkIcon"><i class="iconfont icon-zuobiao"></i>1001 Greenland Hechuang BuildingNo.450 Caoyang Road, Putuo District,Shanghai</span></div>

            </div>
          </div>
        </div>
        <div class="footerRight tr">
          <router-link to="/" >
            <img src="@/assets/images/footLogo.jpg" />
          </router-link>
          <footerShaer/>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import areaNav from '@/components/areaNav.vue'
import footerShaer from '@/components/footerShaer.vue'

import {WOW} from '@/assets/js/wow.js'
export default {
  components:{
    areaNav,footerShaer
  },
  data () {
    return {
      areaNavOpen:false,
      visionListNavIndex:0,
      visionListNav:['Mission','Value'],
      visionList:[{
        title:'Place',
        content:'Create a positive and sustainable work environment that enables employees to realize their value in an effective and cheerful work.',
        pic:require('@/assets/images/p5.jpg')
      },
      {
        title:'Professionalism',
        content:'To utilize innovative design,professional service and efficient exhibiting solutions to create significant value for customer.',
        pic:require('@/assets/images/p55.jpg')
      },
      {
        title:'Partner',
        content:'Create a positive and sustainable work environment that enables employees to realize their value in an effective and cheerful work.',
        pic:require('@/assets/images/p555.jpg')
      }],
      navBarFixed: false,
    }
  },
  mounted() {
    new WOW().init()

  window.addEventListener("scroll", this.watchScroll);
  },
  destroyed() {
    // 移除事件监听
    window.removeEventListener("scroll", this.watchScroll);
  },
  methods:{
    watchScroll() {
      // 滚动的距离
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;

      // 容器的高度
      var offsetTop = document.querySelector("#header").offsetHeight;



      //  滚动的距离如果大于了元素到顶部的距离时，实现吸顶效果
      if (scrollTop > offsetTop) {
        this.navBarFixed = true;
      } else {
        this.navBarFixed = false;
      }
    },
    navSwitch(){
      this.areaNavOpen = !this.areaNavOpen
    },
    visionTabsClick(index){
      this.visionListNavIndex = index
    },
    scrollToSection(sectionId){
      const section = document.getElementById(sectionId);
      if (section) {
        section.scrollIntoView({ behavior: 'smooth' });
      }

    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/view/index.vue